// DEPENDENCIES
import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom';
// CUSTOM COMPONENTS
import AutomatedReportEmailListingPage from './automatedReportEmailListingPage';

const AutomatedReportDetailPage = (props) => {
    const { history } = props;
    var { reportId } = useParams();
    var stateHistory = history.location.state;
    
    return (
        <AutomatedReportEmailListingPage
            reportName={stateHistory ? stateHistory.reportName : ""}
            reportId={reportId}
        />
    );
}

export default AutomatedReportDetailPage;